// Per-city content for location landing pages. Each page has unique copy and
// neighborhoods so the pages are genuinely distinct (not thin "doorway" pages).

const locations = [
  {
    slug: 'aba-therapy-san-jose',
    city: 'San Jose',
    title: 'ABA Therapy in San Jose, CA | In-Home Autism Services | Ohana Therapies',
    description:
      'In-home ABA therapy for children with autism across San Jose, CA. Ohana Therapies offers individualized, family-centered care with insurance support. Now accepting new families.',
    keywords:
      'ABA therapy San Jose, autism therapy San Jose, in-home ABA San Jose, applied behavior analysis San Jose, autism services San Jose CA',
    intro:
      'Ohana Therapies brings compassionate, in-home ABA (Applied Behavior Analysis) therapy to families throughout San Jose. As the largest city in the Bay Area, San Jose is home to a diverse community of families seeking expert autism support — and our team comes directly to you, delivering individualized care in the environment where your child feels most comfortable.',
    areasLine:
      'We serve families across every corner of San Jose, from the historic neighborhoods on the west side to the growing communities in the east and south.',
    neighborhoods: [
      'Willow Glen',
      'Almaden Valley',
      'Evergreen',
      'Berryessa',
      'Cambrian Park',
      'Rose Garden',
      'Silver Creek',
      'Santa Teresa',
      'Blossom Valley',
      'North San Jose',
    ],
    whyCity:
      'San Jose families choose Ohana because we meet them where they are — literally. Instead of navigating traffic to a clinic, your child receives one-on-one ABA therapy at home, and caregivers get hands-on training so progress continues every day of the week.',
    faqs: [
      {
        question: 'Do you provide in-home ABA therapy throughout San Jose?',
        answer:
          'Yes. Our behavior technicians and supervisors travel to families across San Jose — including Willow Glen, Almaden Valley, Evergreen, Berryessa, and surrounding neighborhoods — so your child can learn at home.',
      },
      {
        question: 'How soon can we start ABA therapy in San Jose?',
        answer:
          'Availability varies by area and insurance. The fastest way to get started is to join our waitlist — our team will reach out to walk you through insurance verification and scheduling.',
      },
    ],
  },
  {
    slug: 'aba-therapy-santa-clara',
    city: 'Santa Clara',
    title: 'ABA Therapy in Santa Clara, CA | In-Home Autism Care | Ohana Therapies',
    description:
      'Family-centered, in-home ABA therapy for children with autism in Santa Clara, CA. Ohana Therapies provides individualized programs and insurance support. Join our waitlist.',
    keywords:
      'ABA therapy Santa Clara, autism therapy Santa Clara, in-home ABA Santa Clara, applied behavior analysis Santa Clara, autism services Santa Clara CA',
    intro:
      'Ohana Therapies provides in-home ABA therapy for children with autism throughout Santa Clara. In the heart of Silicon Valley, Santa Clara families balance busy schedules — so our in-home model removes the clinic commute and fits therapy into the rhythm of your day, right where your child lives and plays.',
    areasLine:
      'From the neighborhoods around Santa Clara University to the newer communities near Rivermark and along El Camino Real, our team serves families across the city.',
    neighborhoods: [
      'The Old Quad',
      'Rivermark',
      'Santa Clara University area',
      'Downtown Santa Clara',
      'Central Santa Clara',
      'Northside',
      'El Camino Real corridor',
    ],
    whyCity:
      'Santa Clara families value the convenience and consistency of in-home care. Your child works with a dedicated team on a personalized plan, and because sessions happen at home, the skills they build transfer naturally to daily routines.',
    faqs: [
      {
        question: 'Is your ABA therapy available across Santa Clara?',
        answer:
          'Yes. We provide in-home ABA therapy throughout Santa Clara, from the Old Quad and downtown to Rivermark and the neighborhoods along El Camino Real.',
      },
      {
        question: 'Do you accept insurance for ABA therapy in Santa Clara?',
        answer:
          'We work with most major plans, including Santa Clara Family Health Plan, Cigna, and Anthem, and we handle the insurance paperwork so you can focus on your child.',
      },
    ],
  },
  {
    slug: 'aba-therapy-fremont',
    city: 'Fremont',
    title: 'ABA Therapy in Fremont, CA | In-Home Autism Services | Ohana Therapies',
    description:
      'In-home ABA therapy for children with autism in Fremont, CA. Ohana Therapies delivers individualized, family-centered autism care with insurance support. Now accepting families.',
    keywords:
      'ABA therapy Fremont, autism therapy Fremont, in-home ABA Fremont, applied behavior analysis Fremont, autism services Fremont CA',
    intro:
      'Ohana Therapies offers in-home ABA therapy for children with autism throughout Fremont. As one of the East Bay’s most family-oriented cities, Fremont is home to a vibrant, multicultural community — and our team provides culturally sensitive, individualized autism support in the comfort of your own home.',
    areasLine:
      'We serve families across Fremont’s districts, from the historic Niles and Centerville areas to the growing communities near Warm Springs and Mission San Jose.',
    neighborhoods: [
      'Mission San Jose',
      'Irvington',
      'Niles',
      'Centerville',
      'Warm Springs',
      'Ardenwood',
      'Cherry-Guardino',
    ],
    whyCity:
      'Fremont families appreciate that our therapists come to them and take the time to understand each family’s culture, language, and routines. Personalized, in-home ABA means your child learns real-world skills in the setting that matters most — home.',
    faqs: [
      {
        question: 'Do you offer in-home ABA therapy in Fremont?',
        answer:
          'Yes. Our team provides in-home ABA therapy across Fremont, including Mission San Jose, Irvington, Niles, Centerville, and Warm Springs.',
      },
      {
        question: 'How do we get started with ABA therapy in Fremont?',
        answer:
          'Join our waitlist and our team will contact you to guide you through insurance verification, scheduling, and building your child’s individualized program.',
      },
    ],
  },
];

export default locations;
